module.exports = {
  OVERLAY_TYPES: {
    ATTRIBUTION: 'attribution',
    HEADER: 'header',
    LIMITS: 'limits',
    LOADER: 'loader',
    LOGO: 'logo',
    SEARCH: 'search',
    ZOOM: 'zoom'
  },

  MAP_PROVIDER_TYPES: {
    GMAPS: 'googlemaps',
    LEAFLET: 'leaflet'
  },

  GMAPS_BASE_LAYER_TYPES: ['roadmap', 'gray_roadmap', 'dark_roadmap', 'hybrid', 'satellite', 'terrain']
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/constants.js
// module id = 956
// module chunks = 6